import React from 'react';
import '../TermsOfUse.css';

function CustomerService() {
    return (
        <div className="terms-of-use">
            <div className="dflex jc-center">
                <div className="w74">
                    <h4>
                        &nbsp;&nbsp;&nbsp;&nbsp;You can contact 24/7 our Call Center by phone at <span>+994 (51) 404 00 74.</span>
                        For calls from Azerbaijan, the short number: *9999 (for calls from city and mobile operators). 
                        E-mail address: <span>cahangir.qanizade@gmail.com</span>. You can also contact us through the contact form on our website 
                        or Telegram messenger <span>+994 51 404 00 74</span> (only messages, calls to this number are not accepted). 
                        Since additional information and reservation data are most often required to clarify the details, 
                        we advise you to contact us in writing whenever possible.
                    </h4>
                    <br/>
                    <h4>
                        &nbsp;&nbsp;&nbsp;&nbsp;You can contact 24/7 our Call Center by phone at <span>+994 (51) 404 00 74.</span>
                        For calls from Azerbaijan, the short number: *9999 (for calls from city and mobile operators). 
                        E-mail address: <span>cahangir.qanizade@gmail.com</span>. You can also contact us through the contact form on our website 
                        or Telegram messenger <span>+994 51 404 00 74</span> (only messages, calls to this number are not accepted). 
                        Since additional information and reservation data are most often required to clarify the details, 
                        we advise you to contact us in writing whenever possible.
                    </h4>
                    <br/>
                    <h4>
                        &nbsp;&nbsp;&nbsp;&nbsp;You can contact 24/7 our Call Center by phone at <span>+994 (51) 404 00 74.</span>
                        For calls from Azerbaijan, the short number: *9999 (for calls from city and mobile operators). 
                        E-mail address: <span>cahangir.qanizade@gmail.com</span>. You can also contact us through the contact form on our website 
                        or Telegram messenger <span>+994 51 404 00 74</span> (only messages, calls to this number are not accepted). 
                        Since additional information and reservation data are most often required to clarify the details, 
                        we advise you to contact us in writing whenever possible.
                    </h4>
                    <br/>
                    <h4>
                        &nbsp;&nbsp;&nbsp;&nbsp;You can contact 24/7 our Call Center by phone at <span>+994 (51) 404 00 74.</span>
                        For calls from Azerbaijan, the short number: *9999 (for calls from city and mobile operators). 
                        E-mail address: <span>cahangir.qanizade@gmail.com</span>. You can also contact us through the contact form on our website 
                        or Telegram messenger <span>+994 51 404 00 74</span> (only messages, calls to this number are not accepted). 
                        Since additional information and reservation data are most often required to clarify the details, 
                        we advise you to contact us in writing whenever possible.
                    </h4>
                    <br/>
                    <h4>
                        &nbsp;&nbsp;&nbsp;&nbsp;You can contact 24/7 our Call Center by phone at <span>+994 (51) 404 00 74.</span>
                        For calls from Azerbaijan, the short number: *9999 (for calls from city and mobile operators). 
                        E-mail address: <span>cahangir.qanizade@gmail.com</span>. You can also contact us through the contact form on our website 
                        or Telegram messenger <span>+994 51 404 00 74</span> (only messages, calls to this number are not accepted). 
                        Since additional information and reservation data are most often required to clarify the details, 
                        we advise you to contact us in writing whenever possible.
                    </h4>
                    <br/>
                    <h4>
                        &nbsp;&nbsp;&nbsp;&nbsp;You can contact 24/7 our Call Center by phone at <span>+994 (51) 404 00 74.</span>
                        For calls from Azerbaijan, the short number: *9999 (for calls from city and mobile operators). 
                        E-mail address: <span>cahangir.qanizade@gmail.com</span>. You can also contact us through the contact form on our website 
                        or Telegram messenger <span>+994 51 404 00 74</span> (only messages, calls to this number are not accepted). 
                        Since additional information and reservation data are most often required to clarify the details, 
                        we advise you to contact us in writing whenever possible.
                    </h4>
                </div>
            </div>
        </div>
    );
};

export default CustomerService;
